import React, { useState, useEffect } from "react";
import { Card, Col } from "react-bootstrap";
import HeatMapsChart from "../../../../../components/chart/HeatMapsChart";
import PolarChart from "../../../../../components/chart/PolarChart";
import DonutChart from "../../../../../components/chart/DonutChart";
import TreeMapChart from "../../../../../components/chart/TreeMapChart";
import ReactTable from "../../../../../lib/table/react-table";
import {
  GRAPH_FILL_COLOR,
  GRAPH_MINI_FILL_COLOR,
} from "../constant/graph-color-scheme";
import {
  useGetAudienceAgeWiseReport,
  useGetAudienceDayWiseReport,
  useGetAudienceDeviceDistribution,
  useGetAudienceSpecialityCTRReport,
  useGetAudienceSpecialityReport,
  useGetAudienceUserByScreenSize,
  useGetAudienceZonalDistribution,
  useGetSummaryCampaignGroupList,
} from "../../../../../queries/query-hooks/workspace/brand-ads-hook";
import TableHeaderSwiper from "../components/TableHeaderSwiper";
import {
  formatLocalizedDate,
  getWeeksBetween,
  transformGraphData,
} from "../../../../../common/utils/utils";
import SparlLineBar from "../../../../../components/chart/SparlLineBar";
import { useParams } from "react-router-dom";
import SquareChartSkeleton from "../../../../../skeleton/workspace/clirnet/brand-ads/square-chart-skeleton";
import CommonTableLoader from "../../../../../skeleton/common-table-loader";
import NavSwiperSkeleton from "../../../../../skeleton/workspace/clirnet/brand-ads/nav-swiper-skeleton";
import { fallbackImages } from "../../../../../utilities/fallback-images";
import PageNotFound from "../../../../PageNotFound";
import { useGetProjectDetails } from "../../../../../queries/query-hooks/workspace/workspace-hook";
import useCsvDownloader from "../../../../../components/custom-hooks/use-csv-downloader";
import * as dayjs from "dayjs";
import { ProjectHeaderTopBar, TableHeader } from "@ui";
import ProjectFilters from "../components/ProjectFilters";
import { useDispatch, useSelector } from "react-redux";
import { selectProject } from "store/project/project.selector";
import { updateProject } from "store/project/project.action";
const DAYS_OF_WEEK = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

function Audience() {
  const { project_id } = useParams();
  const dispatch = useDispatch();
  const project = useSelector(selectProject);
  const { downloadCSV } = useCsvDownloader();

  const [analysisType, setAnalysisType] = useState("week");

  const { data: projectDetails, isLoading: isProjectDetailsLoading } =
    useGetProjectDetails(project_id);

  const [dateRangePayload, setDateRangePayload] = useState({
    start_date: "",
    end_date: "",
  });
  const [isProjectChange, setIsProjectChange] = useState(false);

  useEffect(() => {
    setIsProjectChange(true);
  }, [project_id]);

  useEffect(() => {
    if (projectDetails && projectDetails?.length > 0) {
      const today = dayjs();
      const projectEndDate = dayjs(projectDetails[0]?.project_end_date);
      let result = projectDetails[0]?.project_end_date;

      if (
        projectEndDate &&
        (projectEndDate.isAfter(today) || projectEndDate.isSame(today, "day"))
      ) {
        result = today.subtract(1, "day");
      } else {
        result = projectEndDate;
      }

      if (project?.start_date && project?.end_date && !isProjectChange) {
        setDateRangePayload({
          start_date: project?.start_date,
          end_date: project?.end_date,
        });
        dispatch(
          updateProject({
            start_date: project?.start_date,
            end_date: project?.end_date,
          })
        );
      } else {
        setDateRangePayload({
          start_date: formatLocalizedDate(
            new Date(projectDetails[0]?.project_start_date),
            "YYYY-MM-DD[T]00:00:00.000Z"
          ),
          end_date: formatLocalizedDate(
            new Date(result),
            "YYYY-MM-DD[T]23:59:59.000Z"
          ),
        });
        dispatch(
          updateProject({
            start_date: formatLocalizedDate(
              new Date(projectDetails[0]?.project_start_date),
              "YYYY-MM-DD[T]00:00:00.000Z"
            ),
            end_date: formatLocalizedDate(
              new Date(result),
              "YYYY-MM-DD[T]23:59:59.000Z"
            ),
          })
        );
        setIsProjectChange(false);
      }
    }
  }, [projectDetails, project_id]);
  const [activeCampaignGroup, setActiveCampaignGroup] = useState({});

  function getGroupIdsCommaSeparated(data) {
    return data.map((item) => item.group_id).join(",");
  }

  const { data: dayWiseDistribution, isLoading: isDaywiseDistributionLoading } =
    useGetAudienceDayWiseReport(
      project_id,
      {
        start_date: dateRangePayload?.start_date,
        end_date: dateRangePayload?.end_date,
        analysis_type: analysisType,
        campaign_list:
          projectDetails && projectDetails?.length > 0
            ? getGroupIdsCommaSeparated(projectDetails[0]?.project_group_data)
            : "",
      },
      !!dateRangePayload?.start_date && !!dateRangePayload?.end_date
    );

  const { data: ageWiseDistribution, isLoading: isAgewiseDistributionLoading } =
    useGetAudienceAgeWiseReport(
      project_id,
      {
        start_date: dateRangePayload?.start_date,
        end_date: dateRangePayload?.end_date,
        campaign_list:
          projectDetails && projectDetails?.length > 0
            ? getGroupIdsCommaSeparated(projectDetails[0]?.project_group_data)
            : "",
      },
      !!dateRangePayload?.start_date && !!dateRangePayload?.end_date
    );
  const { data: screenSizeWiseData, isLoading: isScreenSizeWiseDataLoading } =
    useGetAudienceUserByScreenSize(
      project_id,
      {
        start_date: dateRangePayload?.start_date,
        end_date: dateRangePayload?.end_date,
        campaign_list:
          projectDetails && projectDetails?.length > 0
            ? getGroupIdsCommaSeparated(projectDetails[0]?.project_group_data)
            : "",
      },
      !!dateRangePayload?.start_date && !!dateRangePayload?.end_date
    );

  const {
    data: zoneWiseDistribution,
    isLoading: isZonewiseDistributionLoading,
  } = useGetAudienceZonalDistribution(
    project_id,
    {
      start_date: dateRangePayload?.start_date,
      end_date: dateRangePayload?.end_date,
      campaign_list:
        projectDetails && projectDetails?.length > 0
          ? getGroupIdsCommaSeparated(projectDetails[0]?.project_group_data)
          : "",
    },
    !!dateRangePayload?.start_date && !!dateRangePayload?.end_date
  );

  const {
    data: deviceWiseDistribution,
    isLoading: isDevicewiseDistributionLoading,
  } = useGetAudienceDeviceDistribution(
    project_id,
    {
      start_date: dateRangePayload?.start_date,
      end_date: dateRangePayload?.end_date,
      campaign_list:
        projectDetails && projectDetails?.length > 0
          ? getGroupIdsCommaSeparated(projectDetails[0]?.project_group_data)
          : "",
    },
    !!dateRangePayload?.start_date && !!dateRangePayload?.end_date
  );

  const { data: specialityWiseReport, isLoading: isSpecialityReportFetch } =
    useGetAudienceSpecialityReport(
      project_id,
      {
        start_date: dateRangePayload?.start_date,
        end_date: dateRangePayload?.end_date,
        campaign_list: activeCampaignGroup?.id,
      },
      activeCampaignGroup?.id &&
        !!dateRangePayload?.start_date &&
        !!dateRangePayload?.end_date
        ? true
        : false
    );

  const {
    data: specialityWisectrReport,
    isLoading: isSpecialityctrReportFetch,
  } = useGetAudienceSpecialityCTRReport(
    project_id,
    {
      start_date: dateRangePayload?.start_date,
      end_date: dateRangePayload?.end_date,
      campaign_list: activeCampaignGroup?.id,
    },
    activeCampaignGroup?.id &&
      !!dateRangePayload?.start_date &&
      !!dateRangePayload?.end_date
      ? true
      : false
  );

  const formatDaywiseReportData = (data) => {
    const daysOfWeek = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

    const result = data.reduce((acc, { Day, label, Reach }) => {
      if (!acc[label]) {
        acc[label] = {
          name: analysisType === "week" ? `Week ${label}` : label,
          data: daysOfWeek.map((day) => ({ x: day, y: 0 })),
        };
      }
      const dayIndex = daysOfWeek.indexOf(Day);
      acc[label].data[dayIndex].y = Reach;
      return acc;
    }, {});

    return Object.values(result)
      .sort((a, b) =>
        a.name.localeCompare(b.name, undefined, { numeric: true })
      )
      .map((week) => ({
        name: week.name,
        data: week.data,
      }));
  };

  const performanceDistribution = {
    series:
      dayWiseDistribution && dayWiseDistribution?.length > 0
        ? formatDaywiseReportData(dayWiseDistribution)
        : [],
  };

  const formatAgeGenderData = (inputArray) => {
    return inputArray.reduce((acc, { age_group, gender, user_count }) => {
      const target = acc.find((item) => item.name === gender);
      if (target) {
        target.data.push({ x: age_group, y: user_count });
      } else {
        acc.push({
          name: gender,
          data: [{ x: age_group, y: user_count }],
        });
      }

      return acc;
    }, []);
  };
  const demographicAgeGender = {
    series:
      ageWiseDistribution && ageWiseDistribution?.length > 0
        ? formatAgeGenderData(ageWiseDistribution)
        : [],
  };

  const screenSizeChartOptions = {
    label:
      screenSizeWiseData?.length > 0
        ? transformGraphData(
            screenSizeWiseData,
            "impression_percentage",
            "screen_ratio"
          )?.label
        : [],
    series:
      screenSizeWiseData?.length > 0
        ? transformGraphData(
            screenSizeWiseData,
            "impression_percentage",
            "screen_ratio"
          )?.series
        : [],
    Header: "Users by Screen Size",
  };

  function transformHeatMapData(inputArray) {
    if (!inputArray && inputArray.length === 0) return [];
    return inputArray.map(({ name, user_count }) => ({
      x: name,
      y: user_count,
    }));
  }

  const zonalChartOptions =
    zoneWiseDistribution && zoneWiseDistribution?.length > 0
      ? transformHeatMapData(zoneWiseDistribution)
      : [];

  const TableColumnData = [
    {
      Header: "Specialities",
      columnId: 1,
      accessor: "name",
      disableFilters: true,
      Cell: ({ value }) => (value ? value : 0),
    },
    {
      Header: "Viewed",
      columnId: 3,
      accessor: "views",
      disableFilters: true,
      Cell: ({ value }) => (value ? value : 0),
    },
    {
      Header: "Avg. Frequency",
      columnId: 3,
      accessor: "average_fre",
      disableFilters: true,
      Cell: ({ value }) => (value ? value : 0),
    },
    {
      Header: "Mobile impr",
      columnId: 4,
      accessor: "mobile_imp",
      disableFilters: true,
      Cell: ({ value }) => (value ? value : 0),
    },
    {
      Header: "Web impr",
      columnId: 5,
      accessor: "web_imp",
      disableFilters: true,
      Cell: ({ value }) => (value ? value : 0),
    },
    {
      Header: "Total impr",
      columnId: 6,
      accessor: "total_impr",
      disableFilters: true,
      Cell: ({ value }) => (value ? value : 0),
    },
    {
      Header: "Total CTR",
      columnId: 7,
      accessor: "ctr",
      disableFilters: true,
      Cell: ({ value }) => (value ? value : 0),
    },
    {
      Header: "Trends",
      columnId: 8,
      accessor: "date_Data",
      disableFilters: true,
      Cell: ({ value }) =>
        value && value?.length > 0 ? (
          <SparlLineBar series={value.split(",")} labels={DAYS_OF_WEEK} />
        ) : (
          0
        ),
    },
  ];

  const deviceDistributionChartData = {
    series:
      deviceWiseDistribution?.length > 0
        ? transformGraphData(deviceWiseDistribution, "Device_count", "new_os")
            ?.series
        : [],
    label:
      deviceWiseDistribution?.length > 0
        ? transformGraphData(deviceWiseDistribution, "Device_count", "new_os")
            ?.label
        : [],
  };

  const { data: campaignGroupList, isLoading: isCampaignGroupListLoading } =
    useGetSummaryCampaignGroupList(project_id, {
      campaign_list:
        projectDetails && projectDetails?.length > 0
          ? getGroupIdsCommaSeparated(projectDetails[0]?.project_group_data)
          : "",
    });

  const handleTableCsvDownload = () => {
    downloadCSV(tableCsvFormat);
  };

  const showDemographics =
    projectDetails &&
    projectDetails[0].project_attributes &&
    Array.isArray(projectDetails?.[0]?.project_attributes) &&
    projectDetails?.[0]?.project_attributes?.length > 0
      ? projectDetails?.[0]?.project_attributes?.find(
          (item) => item?.attribute_name === "demographic_by_age"
        )?.attribute_value === "true"
        ? true
        : false
      : true;

  function mergedSpecialityData(locationData, locationMatrix) {
    if (!locationMatrix && locationData) {
      return locationData.map((location) => ({
        ...location,
        unique_views: "loading",
        unique_clicks: "loading",
        ctr: "loading",
      }));
    }
    if (locationData && locationData?.length > 0) {
      const mergedData = locationData.map((location) => {
        const matchingMatrix = locationMatrix.find(
          (matrix) => matrix.name === location.name
        );
        return {
          ...location,
          ...(matchingMatrix || {}),
        };
      });
      return mergedData;
    }
  }

  const specialityTableData = mergedSpecialityData(
    specialityWiseReport,
    specialityWisectrReport
  );

  const tableCsvFormat = {
    header: [
      "Specialities",
      "Viewed",
      "Avg. Frequency",
      "Mobile impr",
      "Web impr",
      "Total impr",
      "Total CTR",
    ],
    column: [
      "name",
      "views",
      "average_fre",
      "mobile_imp",
      "web_imp",
      "total_impr",
      "ctr",
    ],
    // chart: {
    //   header: "Trends",
    //   column: "date_Data",
    // },
    rows: specialityTableData,
  };

  const chartsToShow = [
    !isDaywiseDistributionLoading && dayWiseDistribution?.length > 0,
    projectDetails &&
      showDemographics &&
      !isAgewiseDistributionLoading &&
      ageWiseDistribution?.length > 0,
  ].filter(Boolean).length;

  const allDataLoaded =
    !isDaywiseDistributionLoading &&
    (!showDemographics || !isAgewiseDistributionLoading);

  const allDeviceDataLoaded =
    !isScreenSizeWiseDataLoading &&
    !isZonewiseDistributionLoading &&
    !isDevicewiseDistributionLoading;

  const deviceCharts = [
    {
      key: "screenSize",
      hasData: screenSizeWiseData?.length > 0,
      element: (
        <PolarChart
          labels={screenSizeChartOptions.label}
          series={screenSizeChartOptions.series}
          title={screenSizeChartOptions.Header}
          graphColor={GRAPH_FILL_COLOR}
        />
      ),
    },
    {
      key: "zoneWise",
      hasData: zoneWiseDistribution?.length > 0,
      element: (
        <TreeMapChart title="Zonal Distribution" series={zonalChartOptions} />
      ),
    },
    {
      key: "deviceWise",
      hasData: deviceWiseDistribution?.length > 0,
      element: (
        <DonutChart
          series={deviceDistributionChartData.series}
          title="Device Distribution"
          labels={deviceDistributionChartData.label}
          graphColor={GRAPH_MINI_FILL_COLOR}
          height={320}
        />
      ),
    },
  ].filter((chart) => chart.hasData);

  const colClass =
    {
      1: "col-12",
      2: "col-md-6 col-sm-12",
      3: "col-md-4 col-sm-12",
    }[deviceCharts.length] || "col-md-4 col-sm-12";

  return (
    <div className="row">
      <div className="col-sm-12">
        <ProjectHeaderTopBar
          projectType="Brand Ads"
          title="Audience insights"
          projectStartDate={
            projectDetails?.length > 0
              ? projectDetails[0]?.project_start_date
              : ""
          }
          projectEndDate={
            projectDetails?.length > 0
              ? projectDetails[0]?.project_end_date
              : ""
          }
          isProjectDetailsLoading={isProjectDetailsLoading}
          rightComponent={
            <ProjectFilters
              title="Audience insights"
              dateLabel={dateRangePayload}
              setDateRangePayload={(e) => {
                setDateRangePayload(e);
                if (getWeeksBetween(e.start_date, e.end_date) > 16) {
                  setAnalysisType("month");
                } else {
                  setAnalysisType("week");
                }
              }}
              projectStartDate={
                projectDetails?.length > 0
                  ? projectDetails[0]?.project_start_date
                  : ""
              }
              projectEndDate={
                projectDetails?.length > 0
                  ? projectDetails[0]?.project_end_date
                  : ""
              }
              isProjectDetailsLoading={isProjectDetailsLoading}
            />
          }
        />
      </div>

      <div className="col-12">
        <div className={`mb-4 row row-cols-1 row-cols-md-${chartsToShow}`}>
          {!allDataLoaded ? (
            <>
              <Col md={6} sm={12} className="mb-4">
                <SquareChartSkeleton />
              </Col>
              <Col md={6} sm={12} className="mb-4">
                <SquareChartSkeleton />
              </Col>
            </>
          ) : (
            <>
              <div className="col">
                {!isDaywiseDistributionLoading &&
                dayWiseDistribution?.length > 0 ? (
                  <HeatMapsChart
                    series={performanceDistribution.series}
                    title={"Day Wise Performance Distribution"}
                  />
                ) : isDaywiseDistributionLoading ? (
                  <SquareChartSkeleton />
                ) : null}
              </div>

              {projectDetails && showDemographics && (
                <div className="col">
                  {!isAgewiseDistributionLoading &&
                  ageWiseDistribution?.length > 0 ? (
                    <HeatMapsChart
                      series={demographicAgeGender.series}
                      title={"Demographic by Age and Gender"}
                    />
                  ) : isAgewiseDistributionLoading ? (
                    <SquareChartSkeleton />
                  ) : null}
                </div>
              )}
            </>
          )}
        </div>
      </div>

      {allDeviceDataLoaded ? (
        deviceCharts.length > 0 ? (
          <div className="col-12">
            <div className="row">
              {deviceCharts.map((chart) => (
                <div key={chart.key} className={`mb-4 ${colClass}`}>
                  {chart.element}
                </div>
              ))}
            </div>
          </div>
        ) : null
      ) : (
        <div className="col-12">
          <div className="row">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="col-md-4 col-sm-12 mb-4">
                <SquareChartSkeleton />
              </div>
            ))}
          </div>
        </div>
      )}

      {showDemographics && (
        <div className="col-sm-12">
          <Card>
            <TableHeader
              title="Specialities"
              downloadProps={{
                needCsvDownload:
                  !isSpecialityReportFetch && specialityWiseReport?.length > 0,
                exportCSVHandler: handleTableCsvDownload,
              }}
            />
            {!isCampaignGroupListLoading && campaignGroupList.length > 0 ? (
              <div className="px-md-4 px-3">
                <TableHeaderSwiper
                  className={"me-0 mt-4"}
                  title={campaignGroupList}
                  activeCampaignGroup={activeCampaignGroup}
                  setActiveCampaignGroup={setActiveCampaignGroup}
                />
              </div>
            ) : (
              <div className="px-md-4 px-3">
                <NavSwiperSkeleton />
              </div>
            )}

            <Card.Body>
              {!isSpecialityReportFetch && specialityWiseReport?.length > 0 ? (
                <ReactTable
                  data={specialityTableData}
                  columns={TableColumnData}
                  bordered
                  onTableStateChange={() => {}}
                  recordsTotal={specialityWiseReport?.length}
                  noDataText="no data"
                  noDataImage={fallbackImages.noActionData}
                  isPaginationShow={false}
                />
              ) : isSpecialityReportFetch ? (
                <CommonTableLoader tableRowLength={5} />
              ) : null}
            </Card.Body>
          </Card>
        </div>
      )}
    </div>
  );
}

export default Audience;
